export enum EConfigTypes {
    GET_ENV_START = '[config] get env start',
    GET_ENV_SUCCESS = '[config] get env success',
    GET_ENV_FAIL = '[config] get env fail',
}
